<script lang="ts">
  import type { CallRow } from "../lib/api";
  import CallItem from "./CallItem.svelte";

  let { calls = [] as CallRow[] }: { calls?: CallRow[] } = $props();
</script>

{#if calls.length > 0}
  <div class="section-title">Звонки · {calls.length}</div>
  <section class="calls">
    {#each calls as c (c.id)}
      <CallItem {c} />
    {/each}
  </section>
{/if}

<style>
  .section-title {
    padding: 18px 16px 8px;
    font-family: 'Manrope', sans-serif;
    font-size: 11px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase;
    color: var(--text-dim);
  }
  .calls { padding: 0 16px; display: flex; flex-direction: column; gap: 8px; }
</style>
